import {
  ASSIGNMENT_LOGGING_ACTION,
  USER_TYPE,
  LEAD_STATUS,
  LEAD_CATEGORY,
  PATIENT_ASSIGNMENT,
} from "./enums";

export const PATIENT_ASSIGNMENT_LIST = [
  {
    key: PATIENT_ASSIGNMENT.HOME_HEALTH,
    text: "Home health",
  },
  {
    key: PATIENT_ASSIGNMENT.HOSPICE,
    text: "Hospice",
  },
  {
    key: PATIENT_ASSIGNMENT.CLINIC,
    text: "Clinic",
  },
  {
    key: PATIENT_ASSIGNMENT.SIGN_UP,
    text: "Sign up",
  }
  ,
  {
    key: PATIENT_ASSIGNMENT.ADHC,
    text: "ADHC",
  },
  {
    key: PATIENT_ASSIGNMENT.PHARMACY,
    text: "Pharmacy",
  }
  /*{
    key: PATIENT_ASSIGNMENT.NOT_INTERESTED,
    text: "Not interested",
  },
  {
    key: PATIENT_ASSIGNMENT.SEND_BACK,
    text: "Send back",
  },
  {
    key: PATIENT_ASSIGNMENT.ENGLISH,
    text: "English",
  },
  {
    key: PATIENT_ASSIGNMENT.PASSED_AWAY,
    text: "Passed Away",
  },
  {
    key: PATIENT_ASSIGNMENT.ANSWERING_MATCHING,
    text: "Answering Maching",
  },
  {
    key: PATIENT_ASSIGNMENT.PROBLEM,
    text: "Problem",
  },*/
];

//English, Passed Away, Answering Maching, Problem

export const PA_ACTION_LIST = [
  {
    key: ASSIGNMENT_LOGGING_ACTION.ASSIGN_TO_CU,
    text: "Assign to CU",
  },
  {
    key: ASSIGNMENT_LOGGING_ACTION.SEND_BACK_TO_CU,
    text: "Send back to CU",
  },
  {
    key: ASSIGNMENT_LOGGING_ACTION.ASSIGN_TO_CLOSER,
    text: "Assign to Closer",
  },
  {
    key: ASSIGNMENT_LOGGING_ACTION.MARK_AS_DELETED,
    text: "Mark as deleted",
  },
];

export const USER_TYPE_LIST = [
  {
    key: USER_TYPE.ADMIN,
    text: "Administrator",
  },
  {
    key: USER_TYPE.MANAGER,
    text: "Manager",
  },
  {
    key: USER_TYPE.CENTRAL_USER,
    text: "Central user",
  },
  {
    key: USER_TYPE.CLOSER,
    text: "Closer",
  },
  {
    key: USER_TYPE.STAFF,
    text: "Staff",
  },
];

export const LEAD_STATUS_LIST = [
  {
    key: LEAD_STATUS.OPEN,
    text: "Open",
  },
  {
    key: LEAD_STATUS.DELETED,
    text: "Deleted",
  },
];

export const LEAD_CATEGORY_LIST = [
  {
    key: LEAD_CATEGORY.ALL,
    text: "All",
  },
  {
    key: LEAD_CATEGORY.LEAD,
    text: "Lead",
  },
  {
    key: LEAD_CATEGORY.NOT_INTERESTED,
    text: "Not Interested",
  },
  {
    key: LEAD_CATEGORY.DISCONNECTED,
    text: "Disconnected",
  },
  {
    key: LEAD_CATEGORY.WRONG_NUMBER,
    text: "Wrong Number",
  },
  {
    key: LEAD_CATEGORY.NO_ANSWER,
    text: "No Answer",
  },
  {
    key: LEAD_CATEGORY.IN_PROCESS,
    text: "In Process",
  },
  {
    key: LEAD_CATEGORY.ENGLISH,
    text: "English",
  },
  {
    key: LEAD_CATEGORY.PASSED_AWAY,
    text: "Passed Away",
  },
  {
    key: LEAD_CATEGORY.ANSWERING_MATCHING,
    text: "Answering Maching",
  },
  {
    key: LEAD_CATEGORY.PROBLEM,
    text: "Problem",
  },
  {
    key: LEAD_CATEGORY.DO_NOT_KNOW,
    text: "Do not know",
  },
  {
    key: LEAD_CATEGORY.CALL_BACK,
    text: "Call back",
  },
  {
    key: LEAD_CATEGORY.EMPTY,
    text: "--Empty--",
  },
];



// WEBPACK FOOTER //
// ./client/constants/lists.js